import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=d7acf176&scoped=true"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"
import style0 from "./Pagination.vue?vue&type=style&index=0&id=d7acf176&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7acf176",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7acf176')) {
      api.createRecord('d7acf176', component.options)
    } else {
      api.reload('d7acf176', component.options)
    }
    module.hot.accept("./Pagination.vue?vue&type=template&id=d7acf176&scoped=true", function () {
      api.rerender('d7acf176', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Pagination.vue"
export default component.exports